<div class="sidenav bd-sidebar">
    <a class="btn btn-danger btn-create" [routerLink]="['/create']">{{ "BUTTONS.NEW-MESSAGE" | translate }}</a>
    <ul class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
        <ng-container *ngFor="let folder of this.folders">
            <li class="nav-item">
                <a [ngClass]="activeFolderID == folder.id ? 'nav-link active' : 'nav-link'" *ngIf="folder.type == 'sending'" class="bi bi-box-arrow-right" [routerLink]="['/folders', folder.id]">
                    <span style="vertical-align: top;">
                       {{"FOLDER.SENT"  | translate }}
                    </span>
                </a>
                <a [ngClass]="activeFolderID == folder.id ? 'nav-link active' : 'nav-link'" *ngIf="folder.type == 'receive'" class="bi bi-box-arrow-right" [routerLink]="['/folders', folder.id]">
                    <span style="vertical-align: top;">
                      {{"FOLDER.INBOX"  | translate }} <span class="badge badge-danger" data-toggle="tooltip" data-placement="top" title="{{ 'MESSAGES.FOLDER-INFO' | translate }}">{{folder.notOpen}}</span>
                    </span>
                </a>
                <a [ngClass]="activeFolderID == folder.id ? 'nav-link active' : 'nav-link'" *ngIf="folder.type == 'draft'" class="bi bi-pencil-square" [routerLink]="['/folders', folder.id]">
                    <span style="vertical-align: top;">
                        {{ folder.title }}
                    </span>
                </a>
                <a [ngClass]="activeFolderID == folder.id ? 'nav-link active' : 'nav-link'" *ngIf="folder.type == 'trash'" class="bi bi-trash" [routerLink]="['/folders', folder.id]">
                    <span style="vertical-align: top;">
                      {{"FOLDER.BIN"  | translate }}
                    </span>
                </a>
            </li>
            <li *ngFor="let subfolder of folder.children" class="nav-child">
                <a [ngClass]="activeFolderID == subfolder.id ? 'nav-link active' : 'nav-link'" *ngIf="subfolder.type == 'trash'" class="bi bi-trash" [routerLink]="['/folders', subfolder.id]">
                    <span style="vertical-align: top;">
                        {{ subfolder.title }}
                    </span>
                </a>
                <a [ngClass]="activeFolderID == subfolder.id ? 'nav-link active' : 'nav-link'" *ngIf="subfolder.type == 'sending'" class="bi bi-box-arrow-right" [routerLink]="['/folders', subfolder.id]">
                    <span style="vertical-align: top;">
                        {{ subfolder.title }}
                    </span>
                </a>
                <a [ngClass]="activeFolderID == subfolder.id ? 'nav-link active' : 'nav-link'" *ngIf="subfolder.type == 'draft'" class="bi bi-pencil-square" [routerLink]="['/folders', subfolder.id]">
                    <span style="vertical-align: top;">
                        {{ subfolder.title }}
                    </span>
                </a>
                <a [ngClass]="activeFolderID == subfolder.id ? 'nav-link active' : 'nav-link'" *ngIf="subfolder.type == 'receive'" class="bi bi-box-arrow-right" [routerLink]="['/folders', subfolder.id]">
                    <span style="vertical-align: top;">
                        {{ subfolder.title }} <span class="badge badge-danger" data-toggle="tooltip" data-placement="top" title="{{ 'MESSAGES.FOLDER-INFO' | translate }}">{{subfolder.notOpen}}</span>
                    </span>
                </a>
            </li>
        </ng-container>
    </ul>
    <a class="btn btn-outline-success btn-annuaires" [routerLink]="['/directory']">
        <i class="bi bi-person-lines-fill"></i>
        {{ "BUTTONS.DIRECTORY" | translate }}
    </a>
</div>
